var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showContainer
      ? _c(
          "div",
          {
            staticClass: "bg-secondary-3 border-radius--light",
            class: [
              _vm.classMain,
              `border-left--color-${
                _vm.borderColor ? _vm.borderColor : "secondary-12"
              }`,
              {
                "border--left": _vm.hasBorder
              }
            ],
            style: _vm.cssVars
          },
          [
            _c("div", { staticClass: "row row-container" }, [
              _c(
                "div",
                {
                  staticClass:
                    "ml-3 d-flex align-items-center px-1 d-sm-none d-md-flex",
                  class: { "gradient-toggle": _vm.hasGradient && _vm.hasToggle }
                },
                [
                  _vm.hasToggle
                    ? _c("em", {
                        staticClass: "far font-20",
                        class: {
                          "fa-chevron-circle-right color-primary-2": !_vm.isOpen,
                          "fa-chevron-circle-down color-primary-1": _vm.isOpen,
                          "fa-chevron-circle-right color-secondary-5":
                            _vm.disabled
                        },
                        on: { click: _vm.open }
                      })
                    : _vm._e()
                ]
              ),
              _c(
                "div",
                { staticClass: "col p-2", class: { "ml-2": _vm.hasGradient } },
                [_vm._t("default")],
                2
              )
            ]),
            _c(
              "div",
              {
                staticClass:
                  "row d-flex justify-content-center align-items-center d-md-none d-sm-block bottom-toggle mt-4",
                class: { "gradient-toggle": _vm.hasGradient && _vm.hasToggle }
              },
              [
                _vm.hasToggle
                  ? _c("em", {
                      staticClass: "far font-20",
                      class: {
                        "fa-chevron-circle-right color-primary-2": !_vm.isOpen,
                        "fa-chevron-circle-down color-primary-1": _vm.isOpen,
                        "fa-chevron-circle-right color-secondary-5":
                          _vm.disabled
                      },
                      on: { click: _vm.open }
                    })
                  : _vm._e()
              ]
            )
          ]
        )
      : _vm._e(),
    _vm.isOpen
      ? _c(
          "div",
          {
            staticClass: "bg-secondary-3 border-radius--light p-0",
            class: _vm.classPanel
          },
          [_vm._t("edition")],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }